import './index.css'

function About() {
    return (
        <div className="HomePage">
            <div className="Article About">
                <h2>About</h2>
                <p>See, I <i>could</i> put info here, but I'm too lazy...</p>
            </div>
        </div>
    );
}

export default About;